import styled from 'styled-components'
import { ButtonProps, TextProps } from 'vvs-uikit'
import { space, typography, layout, flexbox, FlexboxProps } from 'styled-system'

export const VvsGotchiActionBaseButton = styled.button<ButtonProps & TextProps & FlexboxProps & { disabled?: boolean }>`
  color: black;
  padding: 16px;
  display: block;
  font-size: 16px;
  line-height: 24px;
  font-family: RetroLandMayhem;
  text-align: center;
  border: 4px solid black;
  border-radius: 12px;
  background: rgb(11, 211, 216);
  background: linear-gradient(
    0deg,
    rgba(11, 211, 216, 1) 0%,
    rgba(11, 211, 216, 1) 50%,
    rgba(0, 254, 255, 1) 50%,
    rgba(0, 254, 255, 1) 100%
  );

  ${space}
  ${typography}
  ${layout}
  ${flexbox}

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`

const VvsGotchiActionButton = styled(VvsGotchiActionBaseButton)`
  transition: transform 0.25s;

  ${({ disabled }) =>
    disabled
      ? `
    opacity: 0.5;
  `
      : `
    &:hover {
      transform: scale(1.025);
    }
    &:active {
      transform: scale(0.95);
    }
  `}
`

export default VvsGotchiActionButton
